import React from 'react';
import withI18next from '~/../hocs/_withI18next';
import Config from '~/config';

const GroupWebsites = withI18next()(({ t, lng, isAboutPage = false }) => {
  const currentYear = new Date().getFullYear();
  const listDomain = Config.getListDomain(lng);
  const acWebsites = [
    {
      site: 'photo_ac',
      link: listDomain.PHOTO_AC,
      logo: `${Config.staticPrefix}/static/assets/image/logo/logo_photo_ac.svg`,
      text_logo: t('free_stock_photos_ac'),
    },
    {
      site: 'illust_ac',
      link: listDomain.ILLUST_AC,
      logo: `${Config.staticPrefix}/static/assets/image/logo/logo_illust.svg`,
      text_logo: t('free_vector_clip_art'),
    },
    {
      site: 'silhouette_ac',
      link: listDomain.SILHOUETTE_AC,
      logo: `${Config.staticPrefix}/static/assets/image/logo/logo_silhouetteAc.svg`,
      text_logo: t('free_vector_silhouettes'),
    },
    {
      site: 'design_ac',
      link: listDomain.DESIGN_AC,
      logo: `${Config.staticPrefix}/static/assets/image/logo/templateAC_logo_grey.svg`,
      text_logo: t('free_design_templates'),
    },
  ];

  const style = isAboutPage ? { padding: 0 } : {};

  return (
    <div className="group-websites" style={style}>
      <div
        className={`group-websites-content ${
          isAboutPage ? 'group-websites-content-about-us' : ''
        }`}
      >
        {isAboutPage ? (
          ''
        ) : (
          <div className="copyright">
            &copy; 2011 - {currentYear} ACworks Co.,Ltd.{' '}
            {t('all_rights_reserved')}
          </div>
        )}
        <div className="websites">
          {acWebsites.map((item) => (
            <a
              key={item.site}
              href={item.link}
              target="_blank"
              className={`website-item ${item.site}`}
              rel="noreferrer"
            >
              <img
                className={`website-logo ${
                  isAboutPage ? 'website-logo-about-us' : ''
                } ${item.site}`}
                src={item.logo}
                alt={item.text_logo}
              />
            </a>
          ))}
        </div>
      </div>
      <style jsx>
        {`
          .group-websites {
            padding: 28px 0 84px 0;
          }
          .group-websites .group-websites-content {
            width: 70%;
            max-width: 1300px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            margin: 0 auto;
          }
          .group-websites .group-websites-content .websites {
            display: flex;
            flex-direction: row;
            align-items: center;
          }
          .group-websites .group-websites-content .websites .website-item {
            margin-left: 56px;
            cursor: pointer;
          }
          .group-websites
            .group-websites-content
            .websites
            .website-item.photo_ac {
            margin-top: 5px;
          }
          .group-websites .group-websites-content .websites .website-logo {
            width: auto;
            height: 25px;
          }
          .group-websites
            .group-websites-content
            .websites
            .website-logo.design_ac {
            height: 30px;
          }
          .group-websites
            .group-websites-content
            .websites
            .website-logo-about-us {
            height: 35px;
          }
          .group-websites
            .group-websites-content
            .websites
            .website-logo-about-us.design_ac {
            height: 40px;
          }
          .group-websites .group-websites-content-about-us {
            justify-content: center;
          }
          @media (max-width: 992px) {
            .group-websites .group-websites-content {
              min-width: 100%;
              width: 100%;
              flex-direction: column;
            }
            .group-websites .websites {
              margin-top: 28px;
            }
          }
        `}
      </style>
    </div>
  );
});

export default GroupWebsites;
